import { render, staticRenderFns } from "./ItineraryDetails.vue?vue&type=template&id=3c8d6e29&scoped=true&"
import script from "./ItineraryDetails.vue?vue&type=script&lang=js&"
export * from "./ItineraryDetails.vue?vue&type=script&lang=js&"
import style0 from "./ItineraryDetails.vue?vue&type=style&index=0&id=3c8d6e29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8d6e29",
  null
  
)

export default component.exports